const shareApiUrl = '//m.rastargame.com'
var ApiUrl = '',
  // 192.168.22.253 local-gamecenter.rastargame.com 晓旺本地环境
  // GAME_CENTER_URL = 'http://local-gamecenter.rastargame.com'
  GAME_CENTER_URL = ''
if (!import.meta.env.DEV) {
  ApiUrl = '//rsvgw.rastargame.com'
  GAME_CENTER_URL = '//gamecenter.rastargame.com'
}

// var ApiUrl = '//rsvgw.rastargame.com'

export const api = {
  // 初始化
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/common-api-init
  init: ApiUrl + '/apiv1/common/init',
  // 获取服务器时间
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/get-server-time
  time: ApiUrl + '/apiv1/common/server-time',
  // 主站服务器时间
  // http://dev-doc.rastargame.com/read/new_china_platform_api/query-server-time
  gameCenterTime: GAME_CENTER_URL + '/pf-apiv1/server-time',
  // 预约状态查询
  // http://dev-doc.rastargame.com/read/china-rsvgw-doc/date-2024.03.07.10.44-check-reserve
  checkState: ApiUrl + '/rsvapiv1/reservation/check-reserve-state',
  // 发送短信
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/rsvgw-sms-send
  send: ApiUrl + '/rsvapiv1/reservation/sms/send',
  // 预约
  // http://dev-doc.rastargame.com/read/china-rsvgw-doc/date-2024.03.07.10.43-do-reserve
  reserve: ApiUrl + '/rsvapiv1/reservation/reserve',
  // 获取文章列表
  // http://dev-doc.rastargame.com/read/china-rsvgw-doc/articles-list
  articles: ApiUrl + '/apiv1/common/articles-list',
  // 文章详情
  // http://dev-doc.rastargame.com/read/china-rsvgw-doc/date-2025.08.08.16.55.55
  details: ApiUrl + '/apiv1/common/articles-info',
  // 获取文章列表(含子栏目)
  // http://dev-doc.rastargame.com/read/china-rsvgw-doc/date-2025.08.08.11.27.09
  articlesSubList: ApiUrl + '/apiv1/common/articles-sublist',
  // 获取文章扩展内容
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.03.11.10.31.44
  additicont: ApiUrl + '/apiv1/common/columns-extend',
  // 获取栏目列表
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.03.08.14.44.41
  columns: ApiUrl + '/apiv1/common/columns-list',
  // 获取栏目扩展字段
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.03.11.10.02.43
  additi: ApiUrl + '/apiv1/common/columns-extend',
  // 微信分享
  share: shareApiUrl + '/share',
  // 获取微信小程序UrlLink
  // http://dev-doc.rastargame.com/read/china-rsvgw-doc/get-wx-minigame-url-link
  wxUrl: ApiUrl + '/rsvapiv1/reservation/wx-url-link',
  // 预约里程碑
  // http://dev-doc.rastargame.com/read/china-rsvgw-doc/date-2024.03.22.12.54.00
  milestone: ApiUrl + '/rsvapiv1/reservation/milestone',
  // 获取不限制的小程序码
  // http://dev-doc.rastargame.com/read/china-rsvgw-doc/date-2024.04.28.15.06.20
  wxQrcode: ApiUrl + '/rsvapiv1/reservation/wx-un-limit-qrcode',
  // 获取小程序跳转链接
  getUrlLink: 'https://publicapi.rastargame.com/platform/wechat/mini-program/get-url-link',
  // 获取抽奖活动信息
  getDrawActivityInfo: ApiUrl + '/rsvapiv1/luck-draw/get-activity-info',
  // 获取抽奖次数
  getDrawNum: ApiUrl + '/rsvapiv1/luck-draw/get-draw-num',
  // 盗墓笔记获取抽奖任务列表
  dmbjTaskList: ApiUrl + '/rsvapiv1/custom/dmbj/luck-draw/task-list',
  // 抽奖
  doDraw: ApiUrl + '/rsvapiv1/luck-draw/do',
  // 实物奖品收货地址上传
  setAddress: ApiUrl + '/rsvapiv1/luck-draw/set-address',
  // 登出
  logout: 'https://pt-u.rastargame.com/cv1/Logout/do_',
  // 抽奖日志
  getDrawLog: ApiUrl + '/rsvapiv1/luck-draw/get-log',
  // 角色列表
  roleList: GAME_CENTER_URL + '/pf-apiv1/comm/role-list',
  // 任务完成上报
  taskReport: ApiUrl + '/rsvapiv1/custom/dmbj/luck-draw/finish-task',
}
